import GA4React from "ga-4-react";

const ga4react = new GA4React(String(import.meta.env.REACT_APP_GA_ID));

export const initGA = async () => {
  if (import.meta.env.PROD) {
    try {
      await ga4react.initialize();
    } catch (error) {
      console.error("Erro ao inicializar Google Analytics:", error);
    }
  }
};

export const trackEvent = (category: string, action: string, label: string) => {
  if (import.meta.env.PROD) {
    ga4react.event(action, label, category);
  }
};
